import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClickButton", "hasPayments"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { actions } from '../../constants/actions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const InvoiceDeleteButton = _ref => {
  let {
      onClickButton,
      hasPayments
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const tooltipMessage = hasPayments ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.components.invoiceActionsDropdown.tooltips.deleteDisabled.hasAssociatedPayment"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.components.invoiceActionsDropdown.tooltips.deleteDisabled.hasActiveSubscription"
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      "data-test-id": "delete-btn-tooltip",
      disabled: !buttonProps.disabled,
      title: tooltipMessage,
      children: /*#__PURE__*/_jsx(Button, Object.assign({
        "data-test-id": "delete-btn",
        use: "tertiary-light",
        responsive: false,
        size: "extra-small",
        onClick: () => onClickButton(actions.DELETE)
      }, buttonProps, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "invoices.components.invoiceActionsDropdown.buttons.delete"
        })
      }))
    }, "delete-btn-tooltip")
  });
};
export default InvoiceDeleteButton;